import React, { } from "react";
import Slider from "react-slick";
import "./deals-of-the-day.scss";

const DealsOfTheDay = ({ dealImages = [], navigate }) => {
  let ExcitingSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 812,
        settings: {
          slidesToShow: dealImages?.length > 3 ? 3 : dealImages?.length,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          initialSlide: 0.5,
          slidesToScroll: 1,
          slidesToShow: 1.5,
        },
      },
    ],
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <Slider {...ExcitingSettings} className="deals-of-the-day-slider-kl exciting-offer-slider-kl">
              {dealImages.map((deal, index) => (
                <div onClick={() => {
                  if (
                    deal.productId.length > 0 &&
                    deal.providerId.length > 0
                  ) {
                    const encodedPId = encodeURIComponent(
                      deal?.providerId
                    );
                    const encodedPCode = encodeURIComponent(
                      deal?.productId
                    );
                    navigate(
                      `/product-details?providerId=${encodedPId}&productCode=${encodedPCode}`,
                      {
                        state: {
                          catalogDataArray: [],
                        },
                      }
                    );
                  }
                }} className="exciting-offer-item-kl" key={index}>
                  <img src={deal?.value ?? ""} alt={`Exciting offer ${index + 1}`} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default DealsOfTheDay;
